import { Suspense, lazy } from 'react';

const lazyRender = (loader) => {
	const LazyComponent = lazy(loader);

	const LazyModalRenderer = (args) => (
		<Suspense fallback={null}>
			<LazyComponent {...args} />
		</Suspense>
	);

	LazyModalRenderer.displayName = 'LazyModalRenderer';

	return LazyModalRenderer;
};

const staticEditModalList = {
	'/static/band': lazyRender(() => import('static-solutions/24155/identity-solution/band/BandEditModal')),
	'/static/function': lazyRender(() => import('static-solutions/24155/identity-solution/function-master/FunctionEditModal')),
	'/static/position': lazyRender(() => import('static-solutions/24155/identity-solution/position-master/PositionEditModal')),
	'/static/leave-policy': lazyRender(() => import('static-solutions/24155/policy-solution/leave/LeaveEditModal')),
	'/static/attendance-shift': lazyRender(() => import('static-solutions/24155/policy-solution/shift/ShiftEditModal')),
	'/static/process-role': lazyRender(() => import('static-solutions/24155/identity-solution/processrole-master/ProcessRoleEditModal')),
	'/static/shift-assignment': lazyRender(() => import('static-solutions/24155/policy-solution/attendance/AttendanceEditModal')),
	'/static/document-group': lazyRender(() => import('static-solutions/24155/identity-solution/document-group/DocumentGroupEditModal')),
	'/static/access-control': lazyRender(() => import('static-solutions/24155/identity-solution/access-control/AccessControlEditModal')),
	'/static/control-testing': lazyRender(() => import('static-solutions/24155/identity-solution/control-testing/ControlTestingEditModal')),
	'/static/compliance-action': lazyRender(() => import('static-solutions/24155/identity-solution/action-repository/ActionRepositoryEditModal')),
	'/static/management-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/management-hierarchy/ManagementHierarchyEditModal')
	),
	'/static/control-questionnaire': lazyRender(
		() => import('static-solutions/24155/identity-solution/control-questionnaire/ControlQuestionnaireEditModal')
	),
	'/static/performance-parameter': lazyRender(
		() => import('static-solutions/24155/identity-solution/performanceParameter/PerformanceParameterModal')
	),
	'/static/assign-control-self-assurance': lazyRender(
		() => import('static-solutions/24155/policy-solution/assign-control-for-self-assurance/AssignControlForSelfAssuranceEditModal')
	),
	'/static/assign-control-self-assurance-v2': lazyRender(
		() => import('static-solutions/24155/policy-solution/assign-control-for-self-assurance-v2/AssignControlForSelfAssuranceV2EditModal')
	),
	'/static/key-management-area': lazyRender(() => import('static-solutions/24155/identity-solution/key-management-area/KeyManagementEditModal')),
	'/static/wht-section': lazyRender(() => import('static-solutions/24155/identity-solution/wht-section/WhtSectionEditModal')),
	'/static/wht-rate-card': lazyRender(() => import('static-solutions/24155/policy-solution/wht-rate-card/WhtRateCardEditModal')),
	'/static/wht-code': lazyRender(() => import('static-solutions/24155/identity-solution/wht-code/WhtCodeEditModal')),
	'/static/services': lazyRender(() => import('static-solutions/24155/identity-solution/services/ServiceEditModal')),
	'/static/materials': lazyRender(() => import('static-solutions/24155/identity-solution/materials/MaterialEditModal')),
	'/static/tax-exemption': lazyRender(() => import('static-solutions/24155/policy-solution/tax-exemption/TaxExemptionEditModal')),
	'/static/asset-accounts-assignment': lazyRender(
		() => import('static-solutions/24155/policy-solution/asset-accounts-assignment/AssetAccountAssignmentEditModal')
	),
	'/static/parent-material': lazyRender(() => import('./24155/identity-solution/accounting-group/AccountingGroupEditModal')),
	'/static/cost-object-type': lazyRender(() => import('./24155/identity-solution/cost-object-type/CostObjectTypeEditModal')),
	'/static/goods-movement-type': lazyRender(() => import('./24155/identity-solution/goods-movement-type/GoodMovementTypeEditModal')),
	'/static/automatic-accounting-rules': lazyRender(
		() => import('./24155/policy-solution/automatic-accounting-rules/AutomaticAccountingRuleEditModal')
	),
	'/static/document-type': lazyRender(() => import('./24155/identity-solution/document-type/DocumentTypeEditModal')),
	'/static/process-group-roles': lazyRender(() => import('./24155/identity-solution/process-group-roles/ProcessGroupRolesEditModal')),
	'/static/allowance': lazyRender(() => import('./24155/identity-solution/allowances/AllowanceEditModal')),
	'/static/pay-scale-group': lazyRender(() => import('static-solutions/24155/identity-solution/pay-scale-group/PayScaleGroupEditModal')),
	'/static/compensation': lazyRender(() => import('static-solutions/24155/identity-solution/compensation/CompensationEditModal')),
	'/static/tax-rule': lazyRender(() => import('static-solutions/24155/policy-solution/tax-rule/TaxRuleEditModal')),
	'/static/performance-rule': lazyRender(() => import('static-solutions/24155/identity-solution/performanceRule/PerformanceRuleEditModal')),
	'/static/shift-design': lazyRender(() => import('static-solutions/24155/policy-solution/shift-design/ShiftDesignEditModal')),
	'/static/lead-creation': lazyRender(() => import('static-solutions/24155/identity-solution/lead-creation/LeadCreationEditModal')),
	'/static/lawer-record-entry': lazyRender(() => import('static-solutions/24155/identity-solution/lawer-record-entry/LawerRecordEntryEditModal')),
	'/static/lead-sla': lazyRender(() => import('static-solutions/24155/identity-solution/lead-sla/LeadSlaEditModal')),
	'/static/lead-sla-configuration': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-sla-configuration/LeadSlaConfigurationEditModal')
	),
	'/static/lead-product': lazyRender(() => import('static-solutions/24155/identity-solution/lead-product/LeadProductEditModal')),
	'/static/lead-stages': lazyRender(() => import('static-solutions/24155/identity-solution/lead-stages/LeadStagesEditModal')),
	'/static/lead-stage-definition-v2': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-stage-definition-v2/LeadStageDefinitionV2EditModal')
	),
	'/static/lead-stage-profile-rules': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-stage-profile-rules/LeadStageProfileRulesEditModal')
	),
	'/static/lead-stage-sla-profiles': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-stage-sla-profiles/LeadStageSlaProfilesEditModal')
	),
	'/static/industry': lazyRender(() => import('static-solutions/24155/identity-solution/industry/IndustryEditModal')),
	'/static/pre-litigation-matter-registration': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-matter-registration/PreLitigationMatterRegistrationEditModal')
	),
	'/static/law-firm-record-entry': lazyRender(
		() => import('static-solutions/24155/identity-solution/law-firm-record-entry/LawFirmRecordEntryEditModal')
	),
	'/static/rate-card-entry': lazyRender(() => import('static-solutions/24155/identity-solution/rate-card-entry/RateCardEntryEditModal')),
	'/static/convert-pre-litigation-to-litigation-case': lazyRender(
		() =>
			import('static-solutions/24155/identity-solution/convert-pre-litigation-to-litigation-case/ConvertPreLitigationToLitigationCaseEditModal')
	),
	'/static/land-document-management': lazyRender(
		() => import('static-solutions/24155/identity-solution/land-document-management/LandDocumentManagementEditModal')
	),
	'/static/land-record': lazyRender(() => import('static-solutions/24155/identity-solution/land-record/LandRecordEditModal')),
	'/static/land-one-time-action-management': lazyRender(
		() => import('static-solutions/24155/identity-solution/land-one-time-action-management/LandOneTimeActionEditModal')
	),

	'/static/pre-litigation-lifecycle-effort-profile': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-lifecycle-effort-profile/PreLitigationLifecycleEffortProfileEditModal')
	),
	'/static/pre-litigation-matters-type': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-matters-type/PreLitigationMattersTypeEditModal')
	),
	'/static/pre-litigation-stage-profile-rules': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-stage-profile-rules/PreLitigationStageProfileRulesEditModal')
	),
	'/static/pre-litigation-stages-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-stages-hierarchy/PreLitigationStagesHierarchyEditModal')
	),
};

export const staticCreateModalList = {
	'/static/band': lazyRender(() => import('static-solutions/24155/identity-solution/band/BandCreateModal')),
	'/static/function': lazyRender(() => import('static-solutions/24155/identity-solution/function-master/FunctionCreateModal')),
	'/static/position': lazyRender(() => import('static-solutions/24155/identity-solution/position-master/PositionCreateModal')),
	'/static/wht-code': lazyRender(() => import('static-solutions/24155/identity-solution/wht-code/WhtCodeCreateModal')),
	'/static/wht-section': lazyRender(() => import('static-solutions/24155/identity-solution/wht-section/WhtSectionCreateModal')),
	'/static/wht-rate-card': lazyRender(() => import('static-solutions/24155/policy-solution/wht-rate-card/WhtRateCardCreateModal')),
	'/static/process-role': lazyRender(() => import('static-solutions/24155/identity-solution/processrole-master/ProcessRoleCreateModal')),
	'/static/control-testing': lazyRender(() => import('static-solutions/24155/identity-solution/control-testing/ControlTestingCreateModal')),
	'/static/key-management-area': lazyRender(() => import('static-solutions/24155/identity-solution/key-management-area/KeyManagementCreateModal')),
	'/static/compliance-action': lazyRender(() => import('static-solutions/24155/identity-solution/action-repository/ActionRepositoryCreateModal')),
	'/static/management-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/management-hierarchy/ManagementHierarchyCreateModal')
	),
	'/static/control-questionnaire': lazyRender(
		() => import('static-solutions/24155/identity-solution/control-questionnaire/ControlQuestionnaireCreateModal')
	),
	'/static/assign-control-self-assurance': lazyRender(
		() => import('static-solutions/24155/policy-solution/assign-control-for-self-assurance/SelfAssuranceCreateModal')
	),
	'/static/assign-control-self-assurance-v2': lazyRender(
		() => import('static-solutions/24155/policy-solution/assign-control-for-self-assurance-v2/SelfAssuranceCreateV2Modal')
	),
	'/static/services': lazyRender(() => import('static-solutions/24155/identity-solution/services/ServiceCreateModal')),
	'/static/materials': lazyRender(() => import('static-solutions/24155/identity-solution/materials/MaterialCreateModal')),
	'/static/tax-exemption': lazyRender(() => import('static-solutions/24155/policy-solution/tax-exemption/TaxExemptionCreateModal')),
	'/static/asset-accounts-assignment': lazyRender(
		() => import('static-solutions/24155/policy-solution/asset-accounts-assignment/AssetAccountAssignmentCreateModal')
	),
	'/static/parent-material': lazyRender(() => import('./24155/identity-solution/accounting-group/AccountingGroupCreateModal')),
	'/static/cost-object-type': lazyRender(() => import('./24155/identity-solution/cost-object-type/CostObjectTypeCreateModal')),
	'/static/goods-movement-type': lazyRender(() => import('./24155/identity-solution/goods-movement-type/GoodMovementTypeCreateModal')),
	'/static/automatic-accounting-rules': lazyRender(
		() => import('./24155/policy-solution/automatic-accounting-rules/AutomaticAccountingRuleCreateModal')
	),
	'/static/document-type': lazyRender(() => import('./24155/identity-solution/document-type/DocumentTypeCreateModal')),
	'/static/compensation': lazyRender(() => import('static-solutions/24155/identity-solution/compensation/CompensationCreateModal')),
	'/static/allowance': lazyRender(() => import('./24155/identity-solution/allowances/AllowanceCreateModal')),
	'/static/pay-scale-group': lazyRender(() => import('static-solutions/24155/identity-solution/pay-scale-group/PayScaleGroupCreateModal')),
	'/static/tax-rule': lazyRender(() => import('static-solutions/24155/policy-solution/tax-rule/TaxRuleCreateModal')),
	'/static/performance-rule': lazyRender(() => import('static-solutions/24155/identity-solution/performanceRule/PerformanceRuleCreateModal')),
	'/static/shift-design': lazyRender(() => import('static-solutions/24155/policy-solution/shift-design/ShiftDesignCreateModal')),
	'/static/shift-assignment': lazyRender(() => import('static-solutions/24155/policy-solution/attendance/AttendanceCreateModal')),
	'/static/lead-creation': lazyRender(() => import('static-solutions/24155/identity-solution/lead-creation/LeadCreationCreateModal')),
	'/static/lawer-record-entry': lazyRender(() => import('static-solutions/24155/identity-solution/lawer-record-entry/LawerRecordEntryCreateModal')),
	'/static/lead-sla': lazyRender(() => import('static-solutions/24155/identity-solution/lead-sla/LeadSlaCreateModal')),
	'/static/lead-sla-configuration': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-sla-configuration/LeadSlaConfigurationCreateModal')
	),
	'/static/lead-product': lazyRender(() => import('static-solutions/24155/identity-solution/lead-product/LeadProductCreateModal')),
	'/static/lead-stages': lazyRender(() => import('static-solutions/24155/identity-solution/lead-stages/LeadStagesCreateModal')),
	'/static/lead-stage-definition-v2': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-stage-definition-v2/LeadStageDefinitionV2CreateModal')
	),
	'/static/lead-stage-profile-rules': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-stage-profile-rules/LeadStageProfileRulesCreateModal')
	),
	'/static/lead-stage-sla-profiles': lazyRender(
		() => import('static-solutions/24155/identity-solution/lead-stage-sla-profiles/LeadStageSlaProfilesCreateModal')
	),
	'/static/industry': lazyRender(() => import('static-solutions/24155/identity-solution/industry/IndustryCreateModal')),
	'/static/pre-litigation-matter-registration': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-matter-registration/PreLitigationMatterRegistrationCreateModal')
	),
	'/static/law-firm-record-entry': lazyRender(
		() => import('static-solutions/24155/identity-solution/law-firm-record-entry/LawFirmRecordEntryCreateModal')
	),
	'/static/rate-card-entry': lazyRender(() => import('static-solutions/24155/identity-solution/rate-card-entry/RateCardEntryCreateModal')),
	'/static/convert-pre-litigation-to-litigation-case': lazyRender(
		() =>
			import('static-solutions/24155/identity-solution/convert-pre-litigation-to-litigation-case/ConvertPreLitigationToLitigationCaseCreateModal')
	),
	'/static/land-document-management': lazyRender(
		() => import('static-solutions/24155/identity-solution/land-document-management/LandDocumentManagementCreateModal')
	),
	'/static/land-record': lazyRender(() => import('static-solutions/24155/identity-solution/land-record/LandRecordCreateModal')),
	'/static/land-one-time-action-management': lazyRender(
		() => import('static-solutions/24155/identity-solution/land-one-time-action-management/LandOneTimeActionCreateModal')
	),

	'/static/pre-litigation-lifecycle-effort-profile': lazyRender(
		() =>
			import('static-solutions/24155/identity-solution/pre-litigation-lifecycle-effort-profile/PreLitigationLifecycleEffortProfileCreateModal')
	),
	'/static/pre-litigation-matters-type': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-matters-type/PreLitigationMattersTypeCreateModal')
	),
	'/static/pre-litigation-stage-profile-rules': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-stage-profile-rules/PreLitigationStageProfileRulesCreateModal')
	),
	'/static/pre-litigation-stages-hierarchy': lazyRender(
		() => import('static-solutions/24155/identity-solution/pre-litigation-stages-hierarchy/PreLitigationStagesHierarchyCreateModal')
	),
};

export default staticEditModalList;
